import React, { FunctionComponent, useEffect } from "react";
import { Field, FormRenderProps, useFormState } from "react-final-form";
import { useQuery } from "react-query";
import { makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Autocomplete from "../../../../components/Autocomplete";
import { useSchoolId } from "../../../school/hooks/useSchoolId";
import { useSchoolStudentsPage } from "../../context/schoolStudentsPageContext";
import useSchoolStudentsQueries from "../../hooks/useSchoolStudentsQueries";

const useStyles = makeStyles(() => ({
  mainContainer: {
    marginTop: 12,
  },
  formControl: {
    marginTop: 26,
  },
}));

export const FilterForm: FunctionComponent<FormRenderProps> = ({
  submitError,
}) => {
  const classes = useStyles();
  const { values } = useFormState();
  const { getSchoolStudents } = useSchoolStudentsPage();
  const { fetchSchoolStudentsCountries, fetchSchoolStudentsNames } =
    useSchoolStudentsQueries();
  const schoolId = useSchoolId();

  const {
    isLoading: isLoadingCountries,
    isFetching: isFetchingCountries,
    data: countriesData,
  } = useQuery<any>(`schoolStudentsCountries${schoolId}`, () =>
    fetchSchoolStudentsCountries(schoolId),
  );
  const {
    isLoading: isLoadingNames,
    isFetching: isFetchingNames,
    data: namesData,
  } = useQuery<any>(`schoolStudentsNames${schoolId}`, () =>
    fetchSchoolStudentsNames(schoolId),
  );

  useEffect(() => {
    getSchoolStudents!(values);
  }, [values?.countries, values?.students]);

  return (
    <form>
      {submitError && <Typography color="error">{submitError}</Typography>}
      <div className={classes.mainContainer}>
        <div>
          <Field
            fullWidth
            multiple={true}
            name="students"
            label="Full Name"
            placeholder="Full Name"
            disableCloseOnSelect
            options={namesData?.data}
            loading={(isFetchingNames || isLoadingNames).toString()}
            disabled={isLoadingNames || isFetchingNames}
            component={Autocomplete}
          />
        </div>
        <div className={classes.formControl}>
          <Field
            fullWidth
            multiple={true}
            name="countries"
            label="Country"
            placeholder="Country"
            disableCloseOnSelect
            options={countriesData?.data}
            loading={(isFetchingCountries || isLoadingCountries).toString()}
            disabled={isLoadingCountries || isFetchingCountries}
            component={Autocomplete}
          />
        </div>
      </div>
    </form>
  );
};

export default React.memo(FilterForm);
